import React, { Component } from 'react'
import ReportMenu from '../../../constants/menu/report'
import { reportTypeService } from '../../../services'
import { auth, exportFile, formatter, validator } from '../../../util'

// UI
import { Button, List, Page, Pager } from '../../../components'
import { Permissions, ReportType } from '../../../constants'
import notify from '../../../components/Notification'
import Skeleton from 'antd/lib/skeleton'
import Spin from 'antd/lib/spin'
import DatePicker from 'antd/lib/date-picker'
import moment from 'moment-timezone'
import '../styles.css'
const { RangePicker } = DatePicker
const ThresholdLowerPercentage = 25
const ThresholdUpperPercentage = 75

const title = `Participants' Plan Details`
const DefaultSort = { end_day_count: 1 }
const timezone = 'Australia/Melbourne'
moment.tz.setDefault(timezone)

class ReportClientPlanDetails extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentPage: 1,
      filter: {},
      list: { list: [], total: 0 },
      isGenerating: false,
      isLoaded: false,
      loading: false,
      loadingList: false,
      sort: Object.assign({}, DefaultSort),
      selectedDateRange: null,
      showDateRangePicker: false,
    }
  }

  componentDidMount () {
    this.fetchReport()
  }

  render () {
    const { currentPage, isGenerating, list, loading, loadingList, showDateRangePicker } = this.state

    const columns = [
      {
        title: 'Participant',
        width: 5,
        key: 'client_fullname',
        render: ({ client_ref_id, client_fullname }) => <a href={`/participants/${client_ref_id}/funding-plan`} rel='noopener noreferrer' target='_blank'>{client_fullname}</a>,
        onSort: (key, order) => this.handleSort({ [key]: order })
      },
      {
        title: 'Plan Allocated Hours',
        width: 2,
        key: 'allocated_hrs',
        render: ({ allocated_hrs }) => <div>{formatter.toFloatDecimal(allocated_hrs)}</div>,
        onSort: (key, order) => this.handleSort({ [key]: order })
      },
      {
        title: 'Usable Hours',
        width: 2,
        key: 'actual_hrs',
        render: ({ is_tbd, actual_hrs }) => is_tbd
          ? <div className='disabled-text'>TBC</div>
          : <div>{formatter.toFloatDecimal(actual_hrs)}</div>,
        onSort: (key, order) => this.handleSort({ [key]: order })
      },
      {
        title: 'Used SC Hours',
        width: 2,
        key: 'sum_job_duration_hrs',
        render: ({ is_tbd, sum_job_duration_hrs, sum_job_duration_hrs_percentage }) => {
          const pcs = formatter.toFloatDecimal(sum_job_duration_hrs_percentage)
          const className = sum_job_duration_hrs_percentage === null
            ? 'disabled-text'
            : pcs >= 100
              ? 'overmax-text'
              : pcs > ThresholdUpperPercentage
                ? 'warning-text'
                : ''
          return (is_tbd
            ? <div className='disabled-text'>TBC</div>
            : <div className={className}>
              <div>{formatter.toFloatDecimal(sum_job_duration_hrs)}</div>
              <div>{`(${pcs}%)`}</div>
            </div>)
        },
        onSort: (key, order) => this.handleSort({ [key]: order })
      },
      {
        title: 'Remaining SC Hours',
        width: 2,
        key: 'remaining_hrs',
        render: ({ is_tbd, remaining_hrs, remaining_hrs_percentage }) => {
          const pcs = formatter.toFloatDecimal(remaining_hrs_percentage)
          const className = remaining_hrs_percentage === null
            ? 'disabled-text'
            : pcs <= 0
              ? 'overmax-text'
              : pcs < ThresholdLowerPercentage
                ? 'warning-text'
                : ''
          return (is_tbd
            ? <div className='disabled-text'>TBC</div>
            : <div className={className}>
              <div>{formatter.toFloatDecimal(remaining_hrs)}</div>
              <div>{`(${pcs}%)`}</div>
            </div>)
        },
        onSort: (key, order) => this.handleSort({ [key]: order })
      },
      {
        title: 'Remaining Plan Days',
        width: 2,
        key: 'end_day_count',
        render: ({ end_day_count, end_day_count_percentage }) => {
          const pcs = formatter.toFloatDecimal(end_day_count_percentage)
          const className = end_day_count_percentage === null
            ? 'overmax-text'
            : pcs <= 0
              ? 'disabled-text'
              : pcs < ThresholdLowerPercentage
                ? 'warning-text'
                : ''
          const pct = end_day_count_percentage === null
            ? 'OVER'
            : pcs == 0
              ? 'Not Started'
              : `${pcs}%`
          return (
            <div className={className}>
              <div>{formatter.toFloatDecimal(end_day_count)} Days</div>
              <div>{`(${pct})`}</div>
            </div>
          )
        },
        onSort: (key, order) => this.handleSort({ [key]: order })
      },
      {
        title: 'Plan Starts On',
        width: 2,
        key: 'period_start_date',
        render: ({ period_start_date }) => <div>{formatter.toShortDate(period_start_date)}</div>,
        onSort: (key, order) => this.handleSort({ [key]: order })
      },
      {
        title: 'Plan Ends On',
        width: 2,
        key: 'period_end_date',
        render: ({ period_end_date }) => <div>{formatter.toShortDate(period_end_date)}</div>,
        onSort: (key, order) => this.handleSort({ [key]: order })
      },
    ]

    return (
      <Page.Body>
        <Page.Left>
          <Page.Menu title='Home' menu={ReportMenu} />
        </Page.Left>


        <Page.Content full>
          <Page.Header title={title}>
            {this.hasAccess(Permissions.REPORT.CLIENT_PLAN_DETAILS.LIST)
              ?
              <>
                <div className="client-task-export-container">
                  <div className="button-container">
                    <Button feedback={isGenerating} onClick={this.toggleDateRangePicker}>
                      Usage Over Time
                    </Button>

                    <Button feedback={isGenerating} onClick={this.export}>
                      EXPORT
                    </Button>
                  </div>

                  {showDateRangePicker && (
                    <div className="range-picker-container">
                      <RangePicker
                        format='YYYY-MM-DD'
                        open={showDateRangePicker}
                        onChange={this.exportUsageOverTime}
                      />
                    </div>
                  )}
                </div>
              </>
              : null}
          </Page.Header>

          <div style={{ marginTop: '24px' }}>
            <Skeleton loading={loading} active>
              <Spin spinning={loadingList}>
                <div className='report'>
                  <div className='report-title'>{`Participants' Plan Details `} <span className='report-tag'>{list.total}</span></div>
                  <List cols={columns} rows={list.list} />

                  <Pager
                    size={list.total}
                    total={list.total}
                    totalText={`Total ${list.total} Record${list.total === 1 ? '' : 's'}`}
                    current={currentPage}
                    onChange={(e) => this.onChangePage(e)}
                    style={{ marginTop: '15px' }}
                  />
                </div>
              </Spin>
            </Skeleton>
          </div>
        </Page.Content>
      </Page.Body>
    )
  }

  onChangePage = (page) => {
    this.setState({ currentPage: page }, () => {
      this.fetchReport()
    })
  }

  toggleDateRangePicker = () => {
    this.setState({ showDateRangePicker: !this.state.showDateRangePicker })
  }

  toggleModal = () => {
    this.setState((prevState) => ({ isModalOpen: !prevState.isModalOpen }));
  }

  handleDateRangeChange = (dates, dateStrings) => {
    this.setState({
      selectedDateRange: dateStrings,
    })
  }

  fetchReport = () => {
    const { currentPage, filter, isLoaded, loading, sort } = this.state
    this.fetchClientReport({ currentPage, filter, isLoaded, loading, sort })
  }

  fetchClientReport = async ({ currentPage, filter, isLoaded = true, loading, sort }) => {
    if (this.hasAccess(Permissions.REPORT.CLIENT_PLAN_DETAILS.LIST)) {
      if (isLoaded) {
        this.setState({ loadingList: true })
      } else {
        this.setState({ loading: true })
      }

      try {
        const list = await reportTypeService.listReport(ReportType.SC_CLIENT_PLAN_DETAILS, filter, sort)

        if (list) {
          this.setState({
            list,
            isLoaded: true,
            loadingList: false,
            loading: false
          })
        } else {
          notify.error(`Unable to get ${title} Report`, 'Please try again later.')
        }
      } catch (e) {
        notify.error(`Unable to get ${title} Report`, 'Please try again later.')
      }

      if (window) window.scrollTo({ top: 0 })
    }
  }

  handleSort = (sort, statusType) => {
    for (var s in sort) {
      if (sort[s] === 0) {
        delete sort[s]
      }
    }

    if (!validator.isNotEmptyObject(sort)) {
      sort = Object.assign({}, DefaultSort)
    }

    this.setState({ sort, currentPage: 1 }, () => {
      this.fetchReport()
    })
  }

  export = async () => {
    try {
      this.setState({ isGenerating: true })

      const r = await exportFile.fetchReportExport(ReportType.SC_CLIENT_PLAN_DETAILS)
      setTimeout(() => {
        this.setState({ isGenerating: false })
      }, 2000)
    } catch (e) {
      this.setState({ isGenerating: false })
      notify.error(`Unable to download ${title} Report`, 'Please try again later.')
    }
  }

  exportUsageOverTime = async (date) => {
    try {
      this.setState({ showDateRangePicker: false, isGenerating: true })

      if (validator.isNotEmptyArray(date) && date.length >= 2) {
        const data = {
          start_date: moment(date[0]).startOf('day').toISOString(),
          end_date: moment(date[1]).endOf('day').toISOString(),
        }
        const r = await exportFile.fetchReportExportUsageOverTime(ReportType.SC_CLIENT_USAGE_OVER_TIME, data)
      } else {
        notify.error('Unable to export tasks', 'Invalid date range selected.')
      }
      setTimeout(() => {
        this.setState({ isGenerating: false, isModalOpen: false })
      }, 2000)
    } catch (e) {
      this.setState({ isGenerating: false, isModalOpen: true })
      notify.error(`Unable to download ${title} Report`, 'Please try again later.')
    }
  }

  hasAccess (accessLevel) {
    return auth.hasAccess(accessLevel)
  }
}

export default ReportClientPlanDetails
